var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize mr-2",attrs:{"color":"secondary","loading":_vm.loading,"x-small":"","outlined":""},on:{"click":function($event){return _vm.notify(_vm.item)}}},[_vm._v("Notify")])
}
var staticRenderFns = []

export { render, staticRenderFns }